// client/src/routes/admin/index.tsx — `/admin` itself · ADM-001.
//
// The area has no dashboard, so the bare URL is not a screen: it redirects to the first tab.
// A landing page that only repeated the two tabs above it would be a click between the
// administrator and the thing they came for.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/accounts' });
  },
});
